import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import AppRouter from "./router";
import { useBrandingStore } from "./store/brandingStore";

export default function App() {
  const loadBranding = useBrandingStore((s) => s.load);
  useEffect(() => { loadBranding(); }, [loadBranding]);

  return (
    <DndProvider backend={HTML5Backend}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </DndProvider>
  );
}
